import MiNotify from './MiNotification.vue'

export default MiNotify
